import React from 'react'
import { Modal, SuspenseBoundary } from 'elements'
import ConnectionChoices from './ConnectionChoices'

export default function SelectConnectionModal({ modal, integrationRowId }) {
  return (
    <Modal modal={modal}>
      <SuspenseBoundary>
        <ConnectionChoices
          integrationRowId={integrationRowId}
          onDone={modal.onClose}
          onClose={modal.onClose}
        />
      </SuspenseBoundary>
    </Modal>
  )
}
